import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const MOBILE_VISUAL = `${process.env.PUBLIC_URL}/assets/therapistview.png`;

const ScreenshotSlot = ({ src, alt, placeholderLabel }) => {
    const [showImg, setShowImg] = React.useState(true);

    if (!showImg) {
        return (
            <Box
                sx={{
                    minHeight: 120,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 2,
                }}
            >
                <Typography
                    component="span"
                    sx={{
                        fontStyle: 'italic',
                        fontSize: { xs: '0.9rem', md: '1rem' },
                        color: 'rgba(22, 163, 74, 0.9)',
                        textAlign: 'center',
                    }}
                >
                    {placeholderLabel}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            component="img"
            src={src}
            alt={alt}
            onError={() => setShowImg(false)}
            sx={{
                width: '100%',
                height: 'auto',
                display: 'block',
                borderRadius: { xs: '12px', md: '16px' },
            }}
        />
    );
};

const TherapistSection = () => {
    return (
        <Box
            component="section"
            id="platform"
            aria-labelledby="platform-heading"
            sx={{
                pt: { xs: 7, md: 7.5, lg: 8 },
                pb: { xs: 4, md: 4.5, lg: 4.5 },
                background: 'linear-gradient(180deg, #FAFBFF 0%, #FFFFFF 45%, #F5F8FF 100%)',
                borderTop: '1px solid rgba(0, 102, 255, 0.06)',
                borderBottom: '1px solid rgba(0, 102, 255, 0.06)',
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto', mb: { xs: 4, md: 5 } }}>
                    <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        FOR THE THERAPIST
                    </Typography>

                    <Typography
                        id="platform-heading"
                        variant="h2"
                        sx={{
                            fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem' },
                            fontWeight: 800,
                            lineHeight: 1.15,
                            letterSpacing: '-0.035em',
                            color: '#0F172A',
                            mb: 2,
                        }}
                    >
                        What the therapist sees on arrival
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: 'auto 1fr' },
                        columnGap: { xs: 0, md: 8 },
                        rowGap: { xs: 2.5, md: 2.5 },
                        alignItems: { xs: 'stretch', md: 'center' },
                        gridTemplateAreas: {
                            xs: `
                "adminVisual"
                "ops"
                "therapist"
                "mobileVisual"
              `,
                            md: `
                "adminVisual ops"
                "therapist mobileVisual"
              `,
                        },
                    }}
                >
                    <Box
                        sx={{
                            gridArea: 'adminVisual',
                            lineHeight: 0,
                            width: 'fit-content',
                            maxWidth: { xs: 300, sm: 350, md: 400, lg: 460 },
                            justifySelf: { xs: 'center', md: 'end' },
                            borderRadius: { xs: '18px', sm: '20px', md: '24px' },
                            overflow: 'hidden',
                        }}
                    >
                        <ScreenshotSlot
                            src={MOBILE_VISUAL}
                            alt="meDZhub mobile app therapist view"
                            placeholderLabel="Visual: Mobile app screenshot"
                        />
                    </Box>

                    <Box
                        sx={{
                            gridArea: 'ops',
                            px: { xs: 2.5, md: 0 },
                            py: { xs: 2.5, md: 0 },
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            maxWidth: { md: 480, lg: 520 },
                        }}
                    >
                        <Typography
                            component="div"
                            sx={{
                                fontSize: { xs: '0.9375rem', md: '1rem' },
                                lineHeight: 1.7,
                                color: 'rgba(15, 23, 42, 0.78)',
                                m: 0,
                                // textAlign: 'left',
                                textAlign: 'justify',
                            }}
                        >
                            Their schedule loads when they open the app. Patient address, session details, check-in prompt. When they arrive, they check in. Location, time, and therapist are recorded automatically. The system knows they were there.
                            <br />
                            Session notes open on-site. Required fields. The form doesn't submit incomplete. There's no way to fill them in from the office the next morning. That's intentional.
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default TherapistSection;